import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'

type ROLE = 'admin' | 'muzred' | 'moderator'

export interface SetNewPasswordDto {
  token: string
  newPassword: string
}
interface State {
  token?: string
  tokenExpiresAt?: number
  refreshToken?: string
  refreshTokenExpiresAt?: number
  role?: ROLE
}

export interface AuthDTO {
  email: string
  password: string
}

export interface AuthResponseDTO {
  token: string
  role?: ROLE
}

export const initialState: State = {}
export const attemptLogin = createAsyncThunk<AuthResponseDTO, AuthDTO>(
  'auth/authorization',
  async (payload) => {
    // const response = await $api.post(
    //   `${payload.isAdmin ? 'admin' : 'user'}/auth`,
    //   payload,
    // )
    const response = await $api.post('admin/auth', payload)
    return response.data
  },
)

export const attemptRequestResetAdminPassword = createAsyncThunk<void, AuthDTO['email']>(
  'auth/request-reset-admin-password',
  async (email) => {
    const response = await $api.post('admin/request-reset-password', {email})
    console.log('response:', response)
  },
)


export const attemptSetAdminPassword = createAsyncThunk<void, SetNewPasswordDto>(
  'auth/set-admin-password',
  async (dto) => {
    console.log('dto:', dto)
    const response = await $api.post('admin/set-password', dto)
    console.log('response:', response)
  },
)

export const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: () => {
      // Handled in store.ts in rootReducer
    },
  },
  extraReducers: (builder) => {
    builder.addCase(attemptLogin.fulfilled, (state, { payload }) => {
      state.token = payload.token
      state.role = payload.role
    })
  },
})

export const { logout } = authReducer.actions
export default authReducer.reducer
